import React, { useEffect, useState } from "react";
import LargeAvatar from "../commons/CircularAvatar/LargeCircularAvatar";
import { UserProfileType } from "../../redux/auth/authTypes";
import { EmailsIcon, TelephoneIcon, locationIcon } from "../../assets/images";
import "./index.scss";
import BoxLoader from "../commons/BoxLoader/BoxLoader";
import {
  formatDate,
  formatDateInYear,
  getDateDifference,
} from "../../utils/commonFunctions";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ViewTeamMembersModal from "./ViewTeamMembersModal";
import { connect } from "react-redux";
import { GetMySpaceViewTeamMembersPayloadType } from "../../commonTypes/mySpaceType";
import { getMyTeamMembersAction } from "../../redux/mySpace";
import { RootState } from "../../redux/rootReducers";
import { ViewTeamMembersDataType } from "../../redux/mySpace/mySpaceTypes";
import { TeamMemberIcon } from "../Icon";
type TabsType = {
  name: string;
  label: string;
  display: boolean | undefined;
};
const tabs: TabsType[] = [
  {
    name: "Employee Reporting You",
    label: "reporting_person",
    display: true,
  },
  {
    name: "Employee I am Coaching",
    label: "coach",
    display: true,
  },
];

type AppProps = {
  userProfileAllData: UserProfileType;
  history: any;
  userId: number | null | undefined;
  fetching: boolean;
  token: string | null;
  dispatchViewMyTeamMembersData: (data: GetMySpaceViewTeamMembersPayloadType) => void;
  viewTeamMemberListData: ViewTeamMembersDataType[] | [];
  totalCount: number;
  dispatchResetTeamMembersData: () => void;
  dispatchResetTeamMembersCount: () => void;
};
const LoggedInUsersProfile = ({
  userProfileAllData,
  history,
  userId,
  fetching,
  token,
  dispatchViewMyTeamMembersData,
  viewTeamMemberListData,
  totalCount,
  dispatchResetTeamMembersData,
  dispatchResetTeamMembersCount,
}: AppProps) => {
  const [viewMyTeamMembersData, setViewMyTeamMembersData] = useState(false);
  const [activeTab, setActiveTab] = useState(tabs[0].label);
  let firstName = userProfileAllData?.user_details?.basic_details?.first_name;
  let lastName = userProfileAllData?.user_details?.basic_details?.last_name;

  let isDefaultEmployee = userProfileAllData?.job_details?.find(
    (jobDetails: any) => jobDetails?.is_default === true
  );

  let reportingPersonFirstName = isDefaultEmployee?.reporting_details
    ?.reporting_person?.first_name
    ? isDefaultEmployee?.reporting_details?.reporting_person?.first_name
    : "";
  let reportingPersonLastName = isDefaultEmployee?.reporting_details
    ?.reporting_person?.last_name
    ? isDefaultEmployee?.reporting_details?.reporting_person?.last_name
    : "";
  const handleUserProfile = () => {
    history.push({
      pathname: `my-space/user-profile/${userId}`,
      state: userProfileAllData,
      userId: userId,
    });
  };
  const handleToggleViewMyTeamModal = () => {
    setViewMyTeamMembersData(!viewMyTeamMembersData);
    setActiveTab(tabs[0].label);
  }

  const handleClick = () => {
    handleToggleViewMyTeamModal();
  }
  useEffect(() => {
    if (activeTab == "reporting_person" && userId) {
      let finalData = {
        token,
        user_id: userId,
        role: "reporting_person",
      };
      dispatchViewMyTeamMembersData(finalData);
      dispatchResetTeamMembersData();
      dispatchResetTeamMembersCount();
    }
    else {
      let finalData = {
        token,
        user_id: userId,
        role: "coach",
      };
      dispatchViewMyTeamMembersData(finalData);
      dispatchResetTeamMembersData();
      dispatchResetTeamMembersCount();
    }
  }, [activeTab])
  return (
    <>
      {fetching ? (
        <BoxLoader />
      ) : (
        <>
          <div style={{ width: "100%", display: "flex" }}>
            <div>
              <LargeAvatar
                name={`${firstName + " " + lastName}`}
                image={userProfileAllData?.user_details?.profile_pic?.file_url}
              />
            </div>
            <div
              className="ml-3"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "5px",
              }}
            >
              <div className="mt-2 d-flex">
                <h3>{`${firstName} ${lastName}`}</h3>
                <button
                  className="btn btn-outline ml-3 d-flex align-items-center"
                  style={{ height: "30px" }}
                  onClick={() => {
                    handleUserProfile();
                  }}
                >
                  View Full Profile
                </button>
                <button
                  className="btn btn-outline ml-3 d-flex align-items-center"
                  style={{ height: "30px" }}
                  onClick={() => {
                    handleClick();
                  }}
                >
                  <span>
                    <TeamMemberIcon /> View My Team
                  </span>
                </button>
              </div>

              <div
                style={{ marginTop: "-6px", marginBottom: "5px" }}
                className="profile-info-heading"
              >
                {isDefaultEmployee?.job_info?.start_date
                  ? getDateDifference(
                    formatDateInYear(isDefaultEmployee?.job_info?.start_date)
                  ) !== "Years: 0, Months: 0, Days: 0"
                    ? getDateDifference(
                      formatDateInYear(
                        isDefaultEmployee?.job_info?.start_date
                      )
                    )
                    : ""
                  : ""}
              </div>

              <div
                style={{ display: "flex", gap: "10%", whiteSpace: "nowrap" }}
              >
                {userProfileAllData?.hr_settings?.work_details?.user_branch
                  ?.branch_name ? (
                  <div className="d-flex">
                    <img
                      style={{ width: "20px", mixBlendMode: "darken" }}
                      src={locationIcon}
                      alt="loction-icon"
                    />
                    <span>
                      {
                        userProfileAllData?.hr_settings?.work_details
                          ?.user_branch?.branch_name
                      }
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {userProfileAllData?.user_details?.basic_details?.email_id ? (
                  <div className="d-flex">
                    <img
                      style={{ width: "20px", mixBlendMode: "darken" }}
                      src={EmailsIcon}
                      alt="email-icon"
                    />
                    <span className="ml-2">
                      {
                        userProfileAllData?.user_details?.basic_details
                          ?.email_id
                      }
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {userProfileAllData?.user_details?.contact_details?.mobile ? (
                  <div className="d-flex">
                    <img
                      style={{ width: "20px", mixBlendMode: "darken" }}
                      src={TelephoneIcon}
                      alt="phone-icon"
                    />
                    <span className="ml-2">
                      {
                        userProfileAllData?.user_details?.contact_details
                          ?.mobile
                      }
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <div style={{ width: "100%" }}>
            <hr></hr>

            <div style={{ display: "flex" }}>
              <div
                style={{
                  display: "flex",
                  gap: "3%",
                  width: "100%",
                  justifyContent: "space-between",
                }}
                className="ml-3"
              >
                <div>
                  <p className="profile-info-heading">Employee ID</p>
                  <p className="mt-1">
                    {isDefaultEmployee?.job_info?.employee_id
                      ? isDefaultEmployee?.job_info?.employee_id
                      : "NA"}
                  </p>
                </div>
                <div>
                  <p className="profile-info-heading">Joining Date</p>
                  <p className="mt-1">
                    {isDefaultEmployee?.job_info?.start_date
                      ? formatDate(isDefaultEmployee?.job_info?.start_date)
                      : "NA"}
                  </p>
                </div>
                <div>
                  <p className="profile-info-heading">Designation</p>
                  <p className="mt-1">
                    {isDefaultEmployee?.job_info?.job_title ? (
                      isDefaultEmployee?.job_info?.job_title?.length > 15 ? (
                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 250 }}
                          overlay={
                            <Tooltip id="button-view-open-item">
                              {isDefaultEmployee?.job_info?.job_title}
                            </Tooltip>
                          }
                        >
                          <span>
                            {isDefaultEmployee?.job_info?.job_title?.slice(
                              0,
                              15
                            )}
                            ...
                          </span>
                        </OverlayTrigger>
                      ) : (
                        <span>{isDefaultEmployee?.job_info?.job_title} </span>
                      )
                    ) : (
                      "NA"
                    )}
                  </p>
                </div>
                <div>
                  <p className="profile-info-heading">Department</p>
                  <p className="mt-1">
                    {/* {isDefaultEmployee?.job_info?.department?.department_name
                      ? isDefaultEmployee?.job_info?.department?.department_name
                      : "NA"} */}

                    {isDefaultEmployee?.job_info?.department
                      ?.department_name ? (
                      isDefaultEmployee?.job_info?.department?.department_name
                        ?.length > 15 ? (
                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 250 }}
                          overlay={
                            <Tooltip id="button-view-open-item">
                              {
                                isDefaultEmployee?.job_info?.department
                                  ?.department_name
                              }
                            </Tooltip>
                          }
                        >
                          <span>
                            {isDefaultEmployee?.job_info?.department?.department_name?.slice(
                              0,
                              15
                            )}
                            ...
                          </span>
                        </OverlayTrigger>
                      ) : (
                        <span>
                          {
                            isDefaultEmployee?.job_info?.department
                              ?.department_name
                          }{" "}
                        </span>
                      )
                    ) : (
                      "NA"
                    )}
                  </p>
                </div>
                <div>
                  <p className="profile-info-heading">Reporting To</p>
                  <p className="mt-1">
                    {reportingPersonFirstName || reportingPersonLastName
                      ? reportingPersonFirstName + " " + reportingPersonLastName
                      : "NA"}
                  </p>
                </div>
                <div>
                  <p className="profile-info-heading">Employment Status</p>
                  <p
                    className={
                      userProfileAllData?.hr_settings?.employment_status ===
                        "Full time"
                        ? `status-complete`
                        : userProfileAllData?.hr_settings?.employment_status ===
                          "Part time"
                          ? "status-incomplete"
                          : userProfileAllData?.hr_settings?.employment_status ===
                            "Intern"
                            ? "status-approval-pending"
                            : userProfileAllData?.hr_settings?.employment_status ===
                              "Probation"
                              ? "manufacturing-journal"
                              : userProfileAllData?.hr_settings?.employment_status ===
                                "Articleship"
                                ? "status-other"
                                : ""
                    }
                    style={{
                      borderRadius: "16px",
                      textAlign: userProfileAllData?.hr_settings
                        ?.employment_status
                        ? "center"
                        : "left",
                      marginTop: "5px",
                    }}
                  >
                    {userProfileAllData?.hr_settings?.employment_status
                      ? userProfileAllData?.hr_settings?.employment_status
                      : "NA"}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {viewMyTeamMembersData == true && (
            <ViewTeamMembersModal
              toggle={handleToggleViewMyTeamModal}
              isOpen={viewMyTeamMembersData}
              data={viewTeamMemberListData}
              totalCount={totalCount}
              tabs={tabs}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          )}
        </>
      )}
    </>
  );
};
const mapStateToProps = (state: RootState) => ({
  viewTeamMemberListData: state.mySpace.viewTeamMembersData,
  totalCount: state.mySpace.viewTeamMembersCount,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchViewMyTeamMembersData: (data: GetMySpaceViewTeamMembersPayloadType) => dispatch(getMyTeamMembersAction(data)),
})
export default connect(mapStateToProps, mapDispatchToProps)(LoggedInUsersProfile);
